import {runInInjectionContext, EnvironmentInjector, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { isObservable, firstValueFrom } from 'rxjs';

/**
 * Sequentially execute an array of CanActivateFn guards in Angular DI context.
 */
export function orderedSyncGuards(
  guards: CanActivateFn[]
): CanActivateFn {
  return async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> => {

    const envInjector = inject(EnvironmentInjector);

    // for (const guard of guards) {
    //   const resultOrObs = await runInInjectionContext(envInjector, () => {
    //     return guard(route, state);
    //   });

    //   let result: boolean | UrlTree;
    //   if (isObservable(resultOrObs)) {
    //     result = await firstValueFrom(resultOrObs);
    //   } else if (resultOrObs instanceof Promise) {
    //     result = await resultOrObs;
    //   } else {
    //     result = resultOrObs as boolean | UrlTree;
    //   }

    //   if (result !== true) {
    //     return result;
    //   }
    // }

    return true;
  };
}


